import React from 'react';
import { Field } from 'formik';
import { withApollo } from '@apollo/client/react/hoc';

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';
import UserSearchQuery from 'buyside/graphql/queries/UserSearch';

const AutocompleteWithFieldContainerProps = props => {
  return <AutocompleteField fieldContainerProps={{ style: { marginBottom: '0px' } }} {...props} />;
};

class UserAutocompleteInput extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, suggestions: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  selectIntercept(value, selectedItem) {
    const { setFieldValue } = this.props;
    setFieldValue('receiverUserId', selectedItem.id);
  }

  changeIntercept(query) {
    this.setState({ loading: true });
    const { setFieldValue } = this.props;
    setFieldValue('receiverUserId', '');
    this.props.client
      .query({
        query: UserSearchQuery,
        variables: { user: query }
      })
      .then(res => {
        const users = res.data.userSearch;
        this.setState({
          loading: false,
          suggestions: users
        });
      });
  }

  render() {
    return (
      <Field
        component={AutocompleteWithFieldContainerProps}
        name={'receiver'}
        changeIntercept={this.changeIntercept}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.suggestions}
        handleSuggestionsClearRequested={() => this.setState({ suggestions: [] })}
        formatSuggestion={suggestion =>
          `${suggestion.displayName} - (${suggestion.currentEmployerName})`
        }
        getSuggestionValue={suggestion =>
          `${suggestion.displayName} - (${suggestion.currentEmployerName})`
        }
        isWide
        loading={this.state.loading}
        debounce
        inputProps={this.props.inputProps}
      />
    );
  }
}

export default withApollo(UserAutocompleteInput);
